// MARK://dhk8/pos/lib/queries/tips
// Queries tipadas de propinas — F4.2 / ADR-0009. El POS lee propinas por el grafo
// (pos-tips, tenant del JWT). Escrituras (registrar propina) siguen REST. Campos inline
// (el preset `client` de codegen NO evalúa interpolaciones en el tag `graphql`).
import { graphql } from '../../gql/index.js'

export const PosTipsQuery = graphql(`
  query PosTips($branchId: String, $serverId: String, $orderId: String, $pooled: Boolean, $from: String, $to: String, $page: Int, $limit: Int) {
    tips(branchId: $branchId, serverId: $serverId, orderId: $orderId, pooled: $pooled, from: $from, to: $to, page: $page, limit: $limit) {
      total
      page
      limit
      items { id tenantId branchId orderId paymentId serverId amountCents pooled createdAt }
    }
  }
`);

export const PosTipQuery = graphql(`
  query PosTip($id: ID!) {
    tip(id: $id) { id tenantId branchId orderId paymentId serverId amountCents pooled createdAt }
  }
`);

export const PosTipSummaryQuery = graphql(`
  query PosTipSummary($branchId: String, $from: String, $to: String) {
    tipSummary(branchId: $branchId, from: $from, to: $to) {
      pooledTotalCents
      directTotalCents
      totalCents
      byServer { serverId totalCents pooledCents directCents }
    }
  }
`);

export const PosCreateTipMutation = graphql(`
  mutation PosCreateTip($input: CreateTipInput!) {
    createTip(input: $input) { id tenantId branchId orderId paymentId serverId amountCents pooled createdAt }
  }
`);
